import { useEffect, useState } from "react";

const ScrollTopComp = () => {
    const hasScroll = window.scrollY > 20;
    const [scroll, setScroll] = useState(hasScroll);
    const displayProp = scroll ? "block" : "none";
    const scrollTop = () => {
        window.scrollTo(0, 0);
    }

    const handleScroll = () => {
        if(window.scrollY > 20) {
            setScroll(true);
        }
        else {
            setScroll(false);
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [])

    return (
        <div onClick={scrollTop} className="scroll-top-button" style={{"display" : displayProp}}><span>{'->'}</span></div>
    )
}

export default ScrollTopComp;